export enum ApiEndpoint {
	portfolio = "portfolio"
}
